import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { authApi } from 'app/api/authApi';

import { localStorageGet, localStorageRemove, localStorageSet } from 'utils/localStorage';

export interface SessionUser {
  id: number;
  name: string;
  roles: string[];
  permissions: string[];
}

export interface Session {
  token: string | null;
  errorMessage: string | null;
  refreshError: boolean;
  sessionStartTime: string | null;
  refresh_token: string | null;
  user: SessionUser | null;
}

export const initialState: Session = {
  token: localStorageGet('token') ?? null,
  user: localStorageGet('user') ?? null,
  sessionStartTime: localStorageGet('sessionStartTime') ?? null,
  refresh_token: localStorageGet('refresh_token') ?? null,
  errorMessage: null,
  refreshError: false,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    clearUserData(state) {
      state.user = null;
      state.token = null;
      state.refresh_token = null;
      state.sessionStartTime = null;
      localStorageRemove('user');
      localStorageRemove('token');
      localStorageRemove('refresh_token');
      localStorageRemove('sessionStartTime');
    },
    setSessionStartTime(state, action: PayloadAction<string | null>) {
      state.sessionStartTime = action.payload;
      localStorageSet('sessionStartTime', action.payload);
    },
    removeData() {
      return initialState;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      const { user, token, refresh_token } = payload;
      state.token = token;
      localStorageSet('token', token);
      state.user = user;
      localStorageSet('user', user);
      state.refresh_token = refresh_token;
      localStorageSet('refresh_token', refresh_token);
    });
    builder.addMatcher(authApi.endpoints.refresh.matchFulfilled, (state, { payload }) => {
      const { user, token, refresh_token } = payload;
      state.token = token;
      localStorageSet('token', token);
      state.user = user;
      localStorageSet('user', user);
      state.refresh_token = refresh_token;
      localStorageSet('refresh_token', refresh_token);
    });
  },
});

export const { clearUserData, removeData, setSessionStartTime } = sessionSlice.actions;

export default sessionSlice.reducer;
